import { customElement, FASTElement, observable } from '@microsoft/fast-element';
import { BuyerInterestTemplate as template } from './buyer-interest.template';
import { BuyerInterestStyles as styles } from './buyer-interest.styles';
import { ICommonService } from '../../../../services';
import { IRfqService } from '../../../../services/rfq.service';
import { ZeroGridPro as zeroAgGrid } from '@genesislcap/foundation-zero-grid-pro';
import { updateArray } from '../../../../utils/dataserver';
import { logger, Message } from '@genesislcap/foundation-comms';
import { IEnumService } from '../../../../services/enum.service';
import { VPPA_RFQ_STATUS } from '../../../../utils';

const name = 'buyer-interest';

@customElement({
  name,
  template,
  styles,
})
export class BuyerInterest extends FASTElement {
  @ICommonService commonService: ICommonService;
  @IRfqService rfqService: IRfqService;
  @IEnumService enumService: IEnumService;

  @observable rfqGrid: zeroAgGrid;
  @observable rfqSubscipton: any;
  @observable rfqList: any[];

  @observable isoValue: string;
  @observable technologyValue: string;
  @observable lmeValue: number;
  @observable minCapacityValue: number;
  @observable maxCapacityValue: number;

  @observable _ISO = [];

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();

    const gridOptions = {
      animateRows: true,
      scrollbarWidth: 10,
      defaultColDef: {
        resizable: true,
        wrapHeaderText: true,
        autoHeaderHeight: true,
      },
    };

    this.rfqGrid.gridOptions = gridOptions;

    this.getAllIso();
  }

  public onGridReady() {
    this.changeColumnsVisibility(false);
    this.populateGrid();
  }

  public populateGrid() {
    let resultList = [];
    this.rfqList = [];
    this.rfqGrid.gridApi.setRowData(this.rfqList);
    this.rfqSubscipton?.unsubscribe();
    this.rfqSubscipton = this.rfqService.getAllRfqs(this.getCriteriaString()).subscribe({
      next: (streamMessage: Message) => {
        resultList = streamMessage.ROW ?? null;
        if (resultList) {
          this.rfqList = updateArray(resultList, this.rfqList).sort(
            (a, b) => a.MODIFIED_AT - b.MODIFIED_AT
          );
          this.rfqGrid.gridApi.setRowData(this.rfqList);
        } else {
          this.rfqList = [];
          this.rfqGrid.gridApi.setRowData(this.rfqList);
          const resultERROR = streamMessage.DETAILS?.ERROR;
          logger.error(resultERROR);
        }
      },
      error: (error: any) => {
        this.rfqList = [];
        logger.error(error);
      },
    });
  }

  private getCriteriaString() {
    const technology = this.technologyValue ? `TECHNOLOGY == '${this.technologyValue}'  && ` : '';
    const iso = this.isoValue ? `ISO == '${this.isoValue}'  && ` : '';
    // let lme = this.lmeValue ? `LME == ${this.lmeValue}  && ` : "";
    const minCapacity = this.minCapacityValue
      ? `REQUESTED_VOLUME >= ${this.minCapacityValue} && `
      : '';
    const maxCapacity = this.maxCapacityValue
      ? `REQUESTED_VOLUME <= ${this.maxCapacityValue} && `
      : '';
    let criteria =
      `(RFQ_STATUS == '${VPPA_RFQ_STATUS.ACTIVE}' || RFQ_STATUS == '${VPPA_RFQ_STATUS.TRADE_PENDING}' || RFQ_STATUS == '${VPPA_RFQ_STATUS.EXISTING_INTEREST}') && `.concat(
        technology,
        iso,
        /* lme,*/ minCapacity,
        maxCapacity
      );
    criteria = criteria.slice(0, -4);

    return criteria;
  }

  private changeColumnsVisibility(isColumnsVisible: boolean) {
    this.rfqGrid['agGridOptions'].columnApi.setColumnVisible('TECHNOLOGY', isColumnsVisible);
    this.rfqGrid['agGridOptions'].columnApi.setColumnVisible('ISO', isColumnsVisible);
    this.rfqGrid['agGridOptions'].columnApi.setColumnVisible('TARGET_COD', isColumnsVisible);
    this.rfqGrid['agGridOptions'].columnApi.setColumnVisible('FIXED_PRICE', isColumnsVisible);
    this.rfqGrid['agGridOptions'].columnApi.setColumnVisible('COLLATERAL', isColumnsVisible);
    this.rfqGrid['agGridOptions'].columnApi.setColumnVisible('NODAL_BASIS', isColumnsVisible);
    this.rfqGrid['agGridOptions'].columnApi.setColumnVisible('LME', isColumnsVisible);
  }

  private getAllIso() {
    this.commonService.getAllIso().then((response) => {
      if (response.REPLY) {
        this._ISO = response.REPLY;
      }
    });
  }

  public isoSelected() {
    // TODO whenFieldChange getAllRfqsWithNewCriteria
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }
}
